export enum TransactionApprovalStatus {
  NotApproved = 1,
  InitialApprovePartial = 2,
  InitialApproveComplete = 3,
  FinalApprove = 4,
}
